import { Stack, Typography, useTheme, Box } from "@mui/material";
import { Button } from 'components';
import React from "react";
import { createStyles, makeStyles } from "@mui/styles";
import { GREY1 } from "constants/colors";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      minWidth: 400,
      maxWidth: 600, 
      flex: "0 0 auto",
      
      [theme.breakpoints.down('lg')]: {
        alignItems: "center",
        textAlign: "center",
        minWidth: "auto",
        maxWidth: "100%",
        width: "100%",
        flex: "1 1 auto",
        paddingLeft: theme.spacing(2),
        boxSizing: "border-box",
      },
      [theme.breakpoints.down('md')]: {
        alignItems: "center",
        textAlign: "center",
        minWidth: "auto",
        maxWidth: "100%",
        width: "100%",
        flex: "1 1 auto",
        paddingLeft: theme.spacing(2),
        boxSizing: "border-box",
      },
    },
    headerStack: {
      width: "100%",
      
      [theme.breakpoints.down('lg')]: {
        alignItems: "center",
      },
      [theme.breakpoints.down('md')]: {
        alignItems: "center",
      },
    },
    title: {
      fontSize: 'clamp(32px, 4vw, 48px)',
      fontWeight: "bold",
      color: GREY1,
      textAlign: "right",
      lineHeight: 1.25,
      alignSelf: "stretch",
      wordBreak: "keep-all",
      overflowWrap: "break-word",
      
      [theme.breakpoints.down('lg')]: {
        textAlign: "center",
        whiteSpace: "normal",
        width: "100%",
        maxWidth: "100%",
        boxSizing: "border-box",
      },
      [theme.breakpoints.down('md')]: {
        textAlign: "center",
        whiteSpace: "normal",
        width: "100%",
        maxWidth: "100%",
        boxSizing: "border-box",
      },
      [theme.breakpoints.down('sm')]: {
      },
    },
    description: {
      fontSize: 'clamp(14px, 4vw, 18px)',
      color: GREY1,
      alignSelf: 'stretch',
      lineHeight: 1.4,
      wordBreak: 'keep-all',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'flex-end',
      gap: theme.spacing(0.5),
    
      [theme.breakpoints.down('lg')]: {
        justifyContent: 'center',
      },
      [theme.breakpoints.down('md')]: {
        justifyContent: 'center',
      },
      [theme.breakpoints.down('sm')]: {
        justifyContent: 'center',
      },
    },
  })
);

export const HeroContent: React.FC = () => {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <Stack spacing={4} alignItems="flex-end" className={classes.root}>
      <Stack spacing={1} alignItems="flex-start" className={classes.headerStack}>
        <Typography variant="h2" className={classes.title}>
          <Box component="span" sx={{ display: { xs: 'none', lg: 'inline' } }}>
            今日的路人
            <br />
            是明日的引路人
          </Box>
          <Box component="span" sx={{ display: { xs: 'inline', lg: 'none' } }}>
            今日的路人是明日的引路人
          </Box>
        </Typography>

        <Typography variant="body1" className={classes.description}>
          <Box component="span" sx={{ whiteSpace: "nowrap" }}>
            NEX Work 是一個非營利線上求職內推平台，
          </Box>
          <Box component="span" sx={{ whiteSpace: { xs: 'normal', sm: 'nowrap' }}}>
            讓台灣人陪著台灣人在國際職涯路上打開一扇窗
          </Box>
        </Typography>
      </Stack>

      <Stack 
        direction="row" 
        spacing={3} 
        alignItems="center"
        sx={{
          [theme.breakpoints.down('lg')]: {
            justifyContent: "center",
          },
          [theme.breakpoints.down('md')]: {
            justifyContent: "center",
          },
        }}
      >
        <Button
          shape="square"
          color="primary"
          href="/signup?type=referrer"
          sx={{ width: 148, minWidth: 148, whiteSpace: 'nowrap' }}
        >
          成為推薦人
        </Button>

        <Button
          shape="square"
          color="secondary"
          href="/signup"
          sx={{ width: 148, minWidth: 148, whiteSpace: 'nowrap' }}
        >
          幫我內推
        </Button>
      </Stack>
    </Stack>
  );
};